import {
    feedUpdateModel,
    feedUpdateImage
} from "../../../../actions/feed-actions"

import buildItemConnector from "../../../common/build-item-connector"

import ViewFeedItemDetails from "./ViewFeedItemDetails"

export default buildItemConnector(
    "feed",
    false,
    feedUpdateModel,
    feedUpdateImage,
    {},
    (presentation) => ({
        fulltext: presentation.fulltext,
        isFetchingFulltext: presentation.isFetchingFulltext
    })
)(ViewFeedItemDetails)
